namespace $.$$ {

	$mol_style_define( $bog_vmap_app_code, {

		flex: { basis: '28rem', grow: 1, shrink: 1 },
		minWidth: 0,

		Title: {
			font: { family: 'monospace' },
		},

		Alarm: {
			whiteSpace: 'pre-wrap',
		},

		Sources: {

			'$mol_switch': {
				alignSelf: 'flex-start',
				flex: { grow: 0 },
			},

		},

	} )

}
